import { DemurrageDetentionStatusEnum } from '../../monitoring/models';
import { DateWithTimezones } from '../../../../common';

export class ShipmentLoadDemurrageAndDetentionAddress {
  name: string | null;
  address: string | null;
}

export class ShipmentLoadDemurrageAndDetention {
  summary: ShipmentLoadDemurrageAndDetentionSummary;
  origin: ShipmentLoadDemurrageAndDetentionContainer;
  destination: ShipmentLoadDemurrageAndDetentionContainer;
}

export class ShipmentLoadDemurrageAndDetentionSummary {
  carrier: string;
  hbl: string;
  consignor: string;
  consignee: string;
  gb: string;
  origin: string;
  actualVesselDeparture: DateWithTimezones;
  estimatedVesselDeparture: DateWithTimezones;
  originDetentionFreeDays: number;
  originDetentionCost: number;
  originDemurrageFreeDays: number;
  originDemurrageCost: number;
  destination: string;
  actualVesselArrival: DateWithTimezones;
  estimatedVesselArrival: DateWithTimezones;
  destinationDetentionCost: number;
  destinationDetentionFreeDays: number;
  destinationDemurrageFreeDays: number;
  destinationDemurrageCost: number;
  totalContainers: number;
  totalCost: number;
  totalCostStatus: DemurrageDetentionStatusEnum;
  currency: string;
}

export class ShipmentLoadDemurrageAndDetentionContainer {
  address: ShipmentLoadDemurrageAndDetentionAddress;
  containers:
    | ShipmentLoadDemurrageAndDetentionOriginContainer[]
    | ShipmentLoadDemurrageAndDetentionDestinationContainer[];
}

export class ShipmentLoadDemurrageAndDetentionOriginContainer {
  emptyContainerPickUp: DateWithTimezones;
  receivedOriginYard: DateWithTimezones;
  fullContainerLoaded: DateWithTimezones;
  container: string;
  detentionDays: number;
  detentionRemainingDays: number;
  detentionCost: number;
  detentionStatus: DemurrageDetentionStatusEnum;
  demurrageDays: number;
  demurrageRemainingDays: number;
  demurrageCost: number;
  demurrageStatus: DemurrageDetentionStatusEnum;
}

export class ShipmentLoadDemurrageAndDetentionDestinationContainer {
  fullContainerDischarge: DateWithTimezones;
  arrivedDestinationContainerYard: DateWithTimezones;
  emptyContainerReturned: DateWithTimezones;
  container: string;
  detentionDays: number;
  detentionRemainingDays: number;
  detentionCost: number;
  detentionStatus: DemurrageDetentionStatusEnum;
  demurrageDays: number;
  demurrageRemainingDays: number;
  demurrageCost: number;
  demurrageStatus: DemurrageDetentionStatusEnum;
}
